import { render, staticRenderFns } from "./ContentTitle.vue?vue&type=template&id=d70c5ae6&scoped=true&"
import script from "./ContentTitle.vue?vue&type=script&lang=ts&"
export * from "./ContentTitle.vue?vue&type=script&lang=ts&"
import style0 from "./ContentTitle.vue?vue&type=style&index=0&id=d70c5ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70c5ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VListItem,VRow})
